/**
 * Cookie Manager Utility
 * Handles reading, writing, and deleting cookies for the application
 */

/**
 * Set a cookie with name, value, and expiration days
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Number of days until expiration (default: 365)
 */
export const setCookie = (name, value, days = 365) => {
  const date = new Date();
  date?.setTime(date?.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date?.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/`;
};

/**
 * Get a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie?.split(';');
  
  for (let i = 0; i < cookies?.length; i++) {
    let cookie = cookies?.[i];
    while (cookie?.charAt(0) === ' ') {
      cookie = cookie?.substring(1);
    }
    if (cookie?.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie?.substring(nameEQ?.length));
    }
  }
  return null;
};

/**
 * Delete a cookie by name
 * @param {string} name - Cookie name
 */
export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};

/**
 * Get Bible reader state from cookies
 * @returns {Object} - Object containing book, chapter, and version
 */
export const getBibleReaderState = () => {
  return {
    book: getCookie('bible_last_book'),
    chapter: getCookie('bible_last_chapter'),
    version: getCookie('bible_last_version')
  };
};

/**
 * Save Bible reader state to cookies
 * @param {string} book - Book name
 * @param {number} chapter - Chapter number
 * @param {string} version - Bible version
 */
export const saveBibleReaderState = (book, chapter, version) => {
  if (book) setCookie('bible_last_book', book);
  if (chapter) setCookie('bible_last_chapter', chapter?.toString());
  if (version) setCookie('bible_last_version', version);
};
